import { VolumetryCalculator } from './volumetry.interface';
import { Volumetry } from './volumetry.interface';
import { BODY_PARTS } from '../body-parts';

export const prostateVolumetryCalculator: VolumetryCalculator = (input): Volumetry[] => {
  const { segmentation, spacing, labels } = input;
  const voxelVolumeMm3 = spacing[0] * spacing[1] * spacing[2];
  
  const counts = new Map<number, number>();
  for (const label of segmentation) {
    if (label !== 0) {
      counts.set(label, (counts.get(label) || 0) + 1);
    }
  }
  
  const labelMap = new Map(labels.map(l => [l.index, l.displayName]));
  const results: Volumetry[] = [];
  
  // Prostate-specific: Calculate total prostate volume
  let totalProstateVoxels = 0;
  const prostateLabels = BODY_PARTS.prostateWithTumourAndZones.labels.map(l => l.displayName); // 
  
  counts.forEach((voxelCount, labelIndex) => {
    // const volumeMl = (voxelCount * voxelVolumeMm3) / 1000;    
    // Accumulate prostate-related volumes
    if (prostateLabels.includes(labelMap.get(labelIndex) || '')) {
      // results.push({
      //   description: labelMap.get(labelIndex) || `Label ${labelIndex}`,
      //   value: volumeMl,
      //   unit: 'ml',
      // });
      totalProstateVoxels += voxelCount;
    }
  });
  
  // Add computed metrics (e.g., PSA density placeholder)
  if (totalProstateVoxels > 0) {
    results.push({
      description: 'Prostate Volume',
      value: (totalProstateVoxels * voxelVolumeMm3) / 1000,
      unit: 'ml',
    });
  }
  if(results.length === 0) {
    results.push({
      description: 'No prostate volume found',
      value: 0,
      unit: 'ml',
    });
  }
  
  return results.sort((a, b) => b.value - a.value);
};